export class BltIframeConstants {
  static readonly SIGNATURE: string = "signature";
  static readonly CHECKBOX: string = "checkbox";
  static readonly TEXTBOX: string = "textbox";
  static readonly SELECT: string = "select";
}
